import * as Sentry from "@sentry/react-native";

import { Config } from "../env";

export function initializeSentry() {
  Sentry.init({
    dsn: Config.sentryPublicDsn,
    tracesSampleRate: 0.2,
    release: Config.releaseName,
    environment: Config.sentryEnv,
  });
  setSentryUser();
}

function setSentryUser() {
  // TODO:
  // getUser().then(Sentry.Browser.setUser);
}
